<div class="main">
    <div *ngIf="showLoader" class="loader">
      <div class="load">
        <mat-spinner></mat-spinner>
      </div>
    </div>
    <div class="section">
      <div class="header">
        <span class="title">
          <div class="label">
            {{'DASHBOARD_SETTINGS.title' | translate}}
          </div>
          <div class="help">
            <!-- <app-help [helpData]="helpData"></app-help> -->
          </div>
        </span>
        <span class="head">{{carrier_unit}}</span>
      </div>
  
      <div class="bodySection">
        <div class="bodyRow">
          <div class="cards">
            <div class="cardHeading">
              {{'DASHBOARD_SETTINGS.deadlineTracker' | translate}}
              <!-- Deadline Tracker -->
              <div class="subheading">{{'DASHBOARD_SETTINGS.expiring' | translate}}</div>
            </div>
            <div class="cardBody">
              <input class="inputField" style="width: 35%;" [(ngModel)]="deadline_expiry.count" type="number" min="1" oninput="validity.valid||(value=0);" placeholder="--">
              <mat-select class="inputField" [(ngModel)]="deadline_expiry.type">
                <mat-option *ngFor="let item of selectOptions" [value]="item">
                  {{item}}
                </mat-option>
              </mat-select>
              <div class="submitButton" (click)="submit(1, deadline_expiry)">
                <div class="button">
                  {{'DASHBOARD_SETTINGS.submit' | translate}}
                  <!-- Submit -->
                </div>
              </div>
            </div>
          </div>
  
          <div class="cards">
            <div class="cardHeading">
              {{'DASHBOARD_SETTINGS.preshipment_status' | translate}}
              <!-- Pre-Shipment -->
              <div class="subheading">{{'DASHBOARD_SETTINGS.next' | translate}}</div>
            </div>
            <div class="cardBody">
              <input class="inputField" style="width: 35%;" [(ngModel)]="shipment_pending.count" type="number" min="1" oninput="validity.valid||(value=0);" placeholder="--">
              <mat-select class="inputField" [(ngModel)]="shipment_pending.type">
                <mat-option *ngFor="let item of selectOptions" [value]="item">
                  {{item}}
                </mat-option>
              </mat-select>
              <div class="submitButton" (click)="submit(2, shipment_pending)">
                <div class="button">
                  {{'DASHBOARD_SETTINGS.submit' | translate}}
                  <!-- Submit -->
                </div>
              </div>
            </div>
          </div>

          <div class="cards">
            <div class="cardHeading">
              {{'DASHBOARD_SETTINGS.acceptance_status' | translate}}
              <!-- Pre-Shipment -->
              <div class="subheading">{{'DASHBOARD_SETTINGS.last' | translate}}</div>
            </div>
            <div class="cardBody">
              <input class="inputField" style="width: 35%;" [(ngModel)]="shipment_acceptance.count" type="number" min="1" oninput="validity.valid||(value=0);" placeholder="--">
              <mat-select class="inputField" [(ngModel)]="shipment_acceptance.type">
                <mat-option *ngFor="let item of selectOptions" [value]="item">
                  {{item}}
                </mat-option>
              </mat-select>
              <div class="submitButton" (click)="submit(3, shipment_acceptance)">
                <div class="button">
                  {{'DASHBOARD_SETTINGS.submit' | translate}}
                  <!-- Submit -->
                </div>
              </div>
            </div>
          </div>

          <div class="cards">
            <div class="cardHeading">
              {{'DASHBOARD_SETTINGS.in_transit_shipment_status' | translate}}
              <!-- Ongoing Shipment -->
              <div class="subheading">{{'DASHBOARD_SETTINGS.last' | translate}}</div>
            </div>
            <div class="cardBody">
              <input class="inputField" style="width: 35%;" [(ngModel)]="ongoing_shipment.count" type="number"  min="1" oninput="validity.valid||(value=0);" placeholder="--">
              <mat-select class="inputField" [(ngModel)]="ongoing_shipment.type">
                <mat-option *ngFor="let item of selectOptions" [value]="item">
                  {{item}}
                </mat-option>
              </mat-select>
              <div class="submitButton" (click)="submit(4, ongoing_shipment)">
                <div class="button">
                  {{'DASHBOARD_SETTINGS.submit' | translate}}
                  <!-- Submit -->
                </div>
              </div>
            </div>
          </div>
          <div class="cards post-shipment">
            <div class="cardHeading">
              {{'DASHBOARD_SETTINGS.postShipment' | translate}}
              <!-- Post-Shipment -->
            </div>
            <div class="cardBody">
              <div class="half">
                  <div class="heading">
                      {{'DASHBOARD_SETTINGS.outstanding_epods' | translate}}
                      <!-- Operation Status -->
                      <div class="subheading">{{'DASHBOARD_SETTINGS.last' | translate}}</div>
                  </div>
              <input class="inputField" style="width: 35%;" [(ngModel)]="outstanding_epods.count" type="number" min="1" oninput="validity.valid||(value=0);" placeholder="--">
              <mat-select class="inputField" [(ngModel)]="outstanding_epods.type">
                <mat-option *ngFor="let item of selectOptions" [value]="item">
                  {{item}}
                </mat-option>
              </mat-select>
              <div class="submitButton" (click)="submit(5, outstanding_epods)">
                <div class="button">
                  {{'DASHBOARD_SETTINGS.submit' | translate}}
                  <!-- Submit -->
                </div>
              </div>
              </div>
              <div class="half">
                <div class="heading">
                    {{'DASHBOARD_SETTINGS.fulfilled_shipment_status' | translate}}
                    <!-- Operation Status -->
                    <div class="subheading">{{'DASHBOARD_SETTINGS.last' | translate}}</div>
                </div>
              <input class="inputField" style="width: 35%;" [(ngModel)]="shipment_fulfilled.count" type="number" min="1" oninput="validity.valid||(value=0);" placeholder="--">
              <mat-select class="inputField" [(ngModel)]="shipment_fulfilled.type">
                <mat-option *ngFor="let item of selectOptions" [value]="item">
                  {{item}}
                </mat-option>
              </mat-select>
              <div class="submitButton" (click)="submit(6, shipment_fulfilled)">
                <div class="button">
                  {{'DASHBOARD_SETTINGS.submit' | translate}}
                  <!-- Submit -->
                </div>
              </div>
              </div>
            </div>
          </div>
          <div class="cards overall">
            <div class="cardHeading">
              {{'DASHBOARD_SETTINGS.overallMetrics' | translate}}
              <!-- Overall Metrics -->
            </div>
            <div class="cardBody">
              <div class="half">
                <div class="heading">
                  {{'DASHBOARD_SETTINGS.operationStatus' | translate}}
                  <!-- Operation Status -->
                  <div class="subheading">{{'DASHBOARD_SETTINGS.last' | translate}}</div>
                </div>
                <input class="inputField" style="width: 35%;" [(ngModel)]="operations_status.count" type="number" min="1"
                 oninput="validity.valid||(value=0);" placeholder="--">
                <mat-select class="inputField" [(ngModel)]="operations_status.type">
                  <mat-option *ngFor="let item of selectOptions" [value]="item">
                    {{item}}
                  </mat-option>
                </mat-select>
                <div class="submitButton" (click)="submit(7, operations_status)">
                  <div class="button">
                    {{'DASHBOARD_SETTINGS.submit' | translate}}
                    <!-- Submit -->
                  </div>
                </div>
              </div>
              <div class="half">
                <div class="heading">
                  {{'DASHBOARD_SETTINGS.top_shippers' | translate}}
                  <!-- Top Performing Carriers -->
                  <div class="subheading">{{'DASHBOARD_SETTINGS.last' | translate}}</div>
                </div>
                <input class="inputField" style="width: 35%;" [(ngModel)]="top_shippers.count" type="number" oninput="validity.valid||(value=0);" placeholder="--">
                <mat-select class="inputField" [(ngModel)]="top_shippers.type">
                  <mat-option *ngFor="let item of selectOptions" [value]="item">
                    {{item}}
                  </mat-option>
                </mat-select>
                <div class="submitButton" (click)="submit(8, top_shippers)">
                  <div class="button">
                    {{'DASHBOARD_SETTINGS.submit' | translate}}
                    <!-- Submit -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  